import axios from 'axios'

export const cancelDeployment = async (deployId, { id }) => {
  const url = process.env.REACT_APP_ADMIN_API + `/cancel/${id}/${deployId}`
  console.log(url)
  const response = await axios.get(url, {})
  return response.data.vercelResponse
}
